import React, {useState} from "react";
import {books_data} from "../../data/books_data";
import Meta from "../../components/Meta";
import BookItem from "../../components/blog/book-item";
import Item from "../../components/list/Item";
import HeaderSection from "../../components/header/HeaderSection";

const Books = () => {
  const [loadMoreBtn, setLoadMoreBtn] = useState(true);
  const [data, setdata] = useState(books_data.slice(0, 100));

  const handleLoadMore = () => {
    setdata(books_data);
    setLoadMoreBtn(false);
  };
  return (
    <>
      <Meta title="Engineering Books - The bookshelf of most suggested and recommended engineering books that every engineer should read"/>

      <HeaderSection title="Bookshelf" subtitle="The Engineering Bookshelf"/>

      {/*<section className="relative py-8 md:py-14">*/}
      {/*  <div className="container">*/}
      {/*    <div className="mx-auto max-w-[48.125rem]">*/}

      {/*      <p className="dark:text-jacarta-60 mb-8 leading-normal">*/}
      {/*        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Architecto cum dicta dignissimos dolorem ea et eum expedita facilis, hic ipsum labore officia perferendis quibusdam ratione,*/}
      {/*        repudiandae sunt tempora, voluptas voluptatem!*/}
      {/*      </p>*/}
      {/*      <Item title="Leadership Path" description=""/>*/}

      {/*      <p className="dark:text-jacarta-60 mb-8 leading-normal">*/}
      {/*        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusantium assumenda corporis cum eos excepturi illo impedit nobis nostrum quasi sapiente sequi sint, voluptatum? Ipsa modi*/}
      {/*        molestias optio sint, voluptates voluptatibus.*/}
      {/*      </p>*/}

      {/*      <Item title="Product Engineer Path" description=""/>*/}
      {/*      <Item title="Backend Engineer Path" description=""/>*/}
      {/*      <Item title="AI Engineer Path" description=""/>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</section>*/}

      <section>
        <div className="py-16 md:py-24">
          <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
            <img
              src="/images/gradient_light.jpg"
              alt="gradient"
              className="h-full w-full"
            />
          </picture>

          <div className="container">

            <BookItem data={data}/>

            {/* <!-- Load More --> */}
            {loadMoreBtn && (
              <div className="mt-10 text-center">
                <button
                  onClick={handleLoadMore}
                  className="bg-accent hover:bg-accent-dark inline-block rounded-full py-3 px-8 text-center font-semibold text-white transition-all"
                >
                  Load More
                </button>
              </div>
            )}
          </div>
        </div>
      </section>

    </>
  );
};

export default Books;
